import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-primary-button',
    templateUrl: './primary-button.component.html',
    standalone: false
})
export class PrimaryButtonComponent implements OnInit {

  @Output() clickEmitter = new EventEmitter();
  @Input() buttonText!: string;
  @Input() type!: string;
  @Input() disabled = false;

  emitClick() {
    this.clickEmitter.emit();
  }

  ngOnInit(): void {
      this.type = this.type || 'button';
  }
}
